import styled from 'styled-components'

const MyDiv = styled.div`
.cards{

 border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    background: #fff;
    // padding: 12px 6px 6px 6px;
    box-shadow:  0px 4px 4px 0px #00000040;
}
`
export default MyDiv
